<template>
  <div>
    <div class="flex items-center mb-5">
      <h3 class="uppercase text-lg font-semibold text-primary tracking-wide">
        Emergency
      </h3>
      <hr class="flex-1 border-primary mx-4" />
      <is-authorized :permissions="['update:staff']">
        <button
          @click="addEmergency()"
          class="
          flex
          items-center
          bg-green-200
          border
          hover:bg-green-300
          border-green-400
          hover:border-green-500
          hover:shadow
          active:shadow-inner
          transition
          duration-300
          text-secondary
          rounded-md
          px-2
          py-1
        "
        >
          <svg class="stroke-current h-5 w-5 mr-2" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
            <path d="M12 5v14M5 12h14" />
          </svg>
          <span>Add Emergency</span>
        </button>
      </is-authorized>
    </div>

    <div class="flex flex-wrap">
      <vue-good-table
        v-if="emergencies.length > 0"
        class="w-full"
        styleClass="vgt-table striped"
        mode="remote"
        :rows="emergencies"
        :columns="columns"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'is_default'">
            <span
              class="px-2 rounded-lg"
              :class="{
                'bg-green-200 text-green-700': props.row.is_default == true,
              }"
              >{{ props.row.is_default ? "Primary" : "" }}</span
            >
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <is-authorized :permissions="['delete:staff']">
              <button
                type="button"
                @click="deleteEmergency(props.row)"
                class="flex items-center ml-2 float-right bg-red-200 border hover:bg-red-300 border-red-400 hover:border-red-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
              >
                <svg
                  class="stroke-current h-5 w-5 mr-2"
                  fill="none"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6" />
                </svg>
                <span></span>
              </button>
            </is-authorized>
            <is-authorized :permissions="['update:staff']">
              <button
                type="button"
                @click="handleEditEmergency(props)"
                class="float-right flex items-center bg-blue-200 border hover:bg-blue-300 border-blue-400 hover:border-blue-500 hover:shadow active:shadow-inner transition duration-300 text-secondary rounded-md px-2 py-1"
              >
                <svg
                  class="stroke-current h-5 w-5 mr-2"
                  fill="none"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                </svg>
                <span></span>
              </button>
            </is-authorized>
          </span>
          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
        </template>
      </vue-good-table>
      <p class="mx-auto my-16" v-if="emergencies.length == 0">
        There are no Emergency contact for this Staff.
      </p>
    </div>

    <portal to="overlay-outlet">
      <panel
        :showing="addEditEmergencyPanelOpen"
        @close="addEditEmergencyPanelOpen = false"
        :title="editingEmergency.emergency_id ? 'Edit Emergency' : 'Add Emergency'"
      >
        <AddEditEmergency :emergency="editingEmergency" @complete="saveEmergency" @delete="deleteEmergency" />
      </panel>
    </portal>

    <portal to="overlay-outlet">
      <confirm-alert :showingConfirm="confirmAlert.showing" :message="confirmAlert.message" @complete="confirmAlert.resultFunction" />
    </portal>
  </div>
</template>

<script>
const Notification = () => import("@/components/Notification.vue");
const ConfirmAlert = () => import("@/components/ConfirmAlert.vue");
const Panel = () => import("@/components/Panel.vue");
const AddEditEmergency = () => import("@/components/Staff/Edit/AddEditEmergency.vue");
const IsAuthorized = () => import("@/components/Auth/IsAuthorized.vue");

export default {
  name: "Emergency",
  components: {
    Notification,
    ConfirmAlert,
    Panel,
    AddEditEmergency,
    IsAuthorized,
  },
  props: {
    emergencies: Array,
  },
  data() {
    return {
      addEditEmergencyPanelOpen: false,
      editingEmergency: {},
      confirmAlert: {
        resultFunction: "",
        showing: false,
        message: "",
        title: "",
        data: "",
      },
      columns: [
        {
          label: "First Name",
          field: "first_name",
          width: "20%",
        },
        {
          label: "Last Name",
          field: "last_name",
          width: "20%",
        },
        {
          label: "Relationship",
          field: "relationship",
          width: "20%",
        },
        {
          label: "Contact",
          field: "contactno",
          width: "20%",
        },

        {
          label: "Type",
          field: "is_default",
          width: "5%",
          // tdClass: this.tblClassCenterAlign,
          // thClass: this.tblClassCenterAlign,
        },
        {
          field: "actions",
          type: "custom",
          width: "15%",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    staff_id: function() {
      return this.$store.state.lastSelectedStaff;
    },
  },
  methods: {
    tblClassLeftAlign(row) {
      return "vgt-left-align";
    },
    tblClassCenterAlign(row) {
      return "vgt-center-align";
    },
    addEmergency: function() {
      this.editingEmergency = {};
      this.addEditEmergencyPanelOpen = true;
    },
    handleEditEmergency: function(selectedRow) {
      let emergencyData = selectedRow.row;
      this.editEmergency(emergencyData);
    },
    editEmergency: function(emergency) {
      this.editingEmergency = { ...emergency };
      this.addEditEmergencyPanelOpen = true;
    },
    saveEmergency: async function(emergency) {
      let msg;
      let isAdd = false;
      if (!emergency.first_name) {
        msg = "Please enter first name.";
      } else if (!emergency.last_name) {
        msg = "Please enter last name.";
      } else if (!emergency.contactno) {
        msg = "Please enter contact no.";
      }

      if (msg) {
        return this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "warning",
                  title: "Error",
                  close: onClose,
                },
              },
              msg
            );
          },
          {
            position: "top-right",
          }
        );
      }

      this.addEditEmergencyPanelOpen = false;

      try {
        if (!emergency.emergency_id) {
          isAdd = true;
          let createResult = await this.StaffService.createEmergencyContact(this.staff_id, emergency);
          emergency.emergency_id = createResult.data.emergency_id;
          this.emergencies.push(emergency);
        } else {
          isAdd = false;
          await this.StaffService.updateEmergencyContact(this.staff_id, emergency.emergency_id, emergency);
          let idx = this.$_.findIndex(this.emergencies, (c) => c.emergency_id == emergency.emergency_id);
          this.emergencies.splice(idx, 1, emergency);
        }

        if (emergency.is_default) {
          this.emergencies.forEach((item) => {
            if (item.emergency_id != emergency.emergency_id) {
              item.is_default = false;
            }
          });
        }

        this.$emit("complete");

        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  title: "Details Saved",
                  close: onClose,
                },
              },
              "Emergency details saved"
            );
          },
          {
            position: "top-right",
          }
        );
      } catch (err) {
        console.error(err);
        let msg = isAdd ? "There was a problem in creating the new Emergency" : "There was a problem in updating the Emergency";

        this.$breadstick.notify(
          ({ h, onClose }) => {
            return h(
              Notification,
              {
                props: {
                  type: "danger",
                  title: "Error",
                  close: onClose,
                },
              },
              msg
            );
          },
          {
            position: "top-right",
          }
        );
      }
    },
    handlePromoteEmergencyToCurrent: async function(result) {
      if (result) {
        this.confirmAlert.showing = false;
        try {
          this.confirmAlert.data.is_default = true;
          await this.saveEmergency(this.confirmAlert.data);
          this.emergencies.forEach((c) => {
            if (c.emergency_id !== this.confirmAlert.data.emergency_id) {
              c.is_default = false;
            }
          });
        } catch (error) {
          console.error(error);
          this.$breadstick.notify(
            ({ h, onClose }) => {
              return h(
                Notification,
                {
                  props: {
                    type: "danger",
                    title: "Error",
                    close: onClose,
                  },
                },
                "There was a problem updating the Emergency"
              );
            },
            {
              position: "top-right",
            }
          );
        }
      }
      this.confirmAlert = {
        resultFunction: "",
        message: "",
        showing: false,
        data: "",
      };
    },
    promoteEmergencyToCurrent: function(emergency) {
      this.confirmAlert = {
        resultFunction: this.handlePromoteEmergencyToCurrent,
        message: `Change '${emergency.last_name}' as current emergency?`,
        showing: true,
        data: emergency,
      };
    },
    handleDeleteEmergency: async function(result) {
      if (result) {
        this.confirmAlert.showing = false;
        try {
          this.isBusy = true;
          await this.StaffService.deleteEmergency(this.staff_id, this.confirmAlert.data.emergency_id);
          let idx = this.$_.findIndex(this.emergencies, (c) => {
            return c.emergency_id == this.confirmAlert.data.emergency_id;
          });

          this.$delete(this.emergencies, idx);
          this.$breadstick.notify(
            ({ h, onClose }) => {
              return h(
                Notification,
                {
                  props: {
                    title: "Emergency Deleted",
                    close: onClose,
                  },
                },
                "Successfully deleted Emergency"
              );
            },
            {
              position: "top-right",
            }
          );
        } catch (err) {
          console.error(err);

          this.$breadstick.notify(
            ({ h, onClose }) => {
              return h(
                Notification,
                {
                  props: {
                    type: "danger",
                    title: "Error",
                    close: onClose,
                  },
                },
                "There was a problem deleting the Emergency"
              );
            },
            {
              position: "top-right",
            }
          );
        }

        this.isBusy = false;
        this.addEditEmergencyPanelOpen = false;
      }
      this.confirmAlert = {
        resultFunction: "",
        message: "",
        showing: false,
        data: "",
      };
    },
    deleteEmergency: function(emergency) {
      if (String(emergency.emergency_id).startsWith("pending")) {
        let idx = this.$_.findIndex(this.emergencies, (c) => {
          return c.emergency_id == emergency.emergency_id;
        });

        this.$delete(this.emergencies, idx);
        return;
      }

      this.confirmAlert = {
        resultFunction: this.handleDeleteEmergency,
        message: `Are you sure you wish to delete '${emergency.last_name}' This cannot be undone.`,
        showing: true,
        data: emergency,
      };
    },
  },
};
</script>
